import queryString from 'query-string';
import React from 'react';
import AuthenticationManager from '../../common/AuthenticationManager';
import LocalStorage from '../../common/LocalStorage';
import { localLog } from '../../loggers/Logger';
import BrowserHistory from '../utils/BrowserHistory';

class Login extends React.Component<any> {
  private authenticationManager: AuthenticationManager;
  private preLoginRouteRegexp = new RegExp(/(?<=;PRE_LOGIN_ROUTE=)((\w|\W)+)/, 'gi');

  constructor(props: any) {
    super(props);
    this.authenticationManager = AuthenticationManager.create();
  }

  async componentDidMount() {
    localLog.debug('Processing token from query string.');
    const queryParams = queryString.parse(this.props.location.search);

    const state = LocalStorage.getAuthState();
    if (state !== queryParams.state) {
      throw new Error('State missmatch.');
    }
    await this.authenticationManager.processToken(queryParams.id_token as string);

    // Redirect back to preLogin route
    const decodedState = decodeURIComponent(queryParams.state as string);
    const preLoginRouteMatches = decodedState.match(this.preLoginRouteRegexp);
    const redirectRoute = preLoginRouteMatches ? preLoginRouteMatches[0] : '/';
    BrowserHistory.push(redirectRoute);
  }

  render() {
    return null;
  }
}

export default Login;
